import { useEffect, useRef, useState } from "react";
import { CycleCountsViewModel } from "../../viewmodels/cycleCounts/CycleCountsViewModel";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import { formatDateWithTime, withRouter } from "../../shared/utility";

import EmptyModal from "../../components/modals/EmptyModal";
import SlideOver from "../../components/slideOver/SlideOver";

import { useNavigate } from "react-router-dom";

import FilterDropdown from "../../components/filterDropdown/FilterDropdown";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import InfiniteScroll from "react-infinite-scroll-component";

function CycleCounts(props) {
  const { addSnackbar, logout } = props;
  const {
    askDeleteCycleCount,
    emptyModal,
    getCycleCounts,
    loading,
    cycleCounts,
    setSlideOver,
    slideOver,
    setEmptyModelOpen,
    showFilters,
    setShowFilters,
    filters,
    filterComponents,
    resetFilters,
    getWarehouseLocations,
    totalCycleCounts,
  } = CycleCountsViewModel(logout, addSnackbar);

  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    getCycleCounts(null, currentPage, filters);
    getWarehouseLocations();
  }, []);

  const searchRef = useRef();

  const handleSearch = () => {
    getCycleCounts(searchRef.current.value, 1, filters);
  };

  function navigateTo(target) {
    navigate(target);
  }

  function bodyFormattedDate(rowData) {
    return <div>{formatDateWithTime(rowData.created_date)}</div>;
  }

  function bodyStatus(rowData) {
    return <div> {rowData.status === 1 ? "Closed" : "Open"}</div>;
  }

  function bodyMoreActions(rowData) {
    return (
      <div>
        <button
          className="rounded-md bg-main-purple px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          onClick={() => navigateTo("/cycle-counts/" + rowData.id)}
        >
          View
        </button>
      </div>
    );
  }

  const handleLoadMoreData = () => {
    setTimeout(() => {
      const nextPage = currentPage + 1;
      setCurrentPage(nextPage);

      getCycleCounts(searchRef.current.value, nextPage, filters);
    }, 250);
  };

  return (
    <div>
      <div className="mt-2">
        <div className="px-4 sm:px-6 lg:px-8">
          <div className="sm:flex sm:items-center px-4 py-5 sm:px-4 card-custom">
            <div className="sm:flex-auto">
              <h1 className="text-base font-semibold leading-6 text-gray-900">
                Cycle Counts
              </h1>
              <div className="mt-5 flex rounded-md">
                <div className="relative flex items-stretch flex-grow focus-within:z-10">
                  <input
                    type="search"
                    name="searchCycleCount"
                    id="searchCycleCount"
                    className="block w-full rounded-lg rounded-l-md pl-2 sm:text-sm border border-gray-300 rounded-tr-none rounded-br-none"
                    placeholder="Search by cycle number"
                    ref={searchRef}
                    onKeyDown={(e) =>
                      e.key === "Enter" ? handleSearch() : null
                    }
                  />
                </div>
                <button
                  type="button"
                  className="-ml-px relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1"
                  onClick={() => handleSearch()}
                >
                  <MagnifyingGlassIcon
                    className="h-5 w-5 text-gray-400"
                    aria-hidden="true"
                  />
                </button>

                <FilterDropdown
                  actionCall={() =>
                    getCycleCounts(searchRef.current.value, 1, filters)
                  }
                  filterComponents={filterComponents}
                  resetFilters={() => {
                    resetFilters();
                  }}
                  showFilters={showFilters}
                  setShowFilters={setShowFilters}
                />
              </div>
            </div>
          </div>
          <div className="mt-8 flow-root">
            <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                {loading ? (
                  <div>
                    <div className="border h-10 shadow rounded-md p-4 w-full mx-auto">
                      <div className="animate-pulse flex space-x-4">
                        Loading
                      </div>
                    </div>
                  </div>
                ) : (
                  <InfiniteScroll
                    dataLength={cycleCounts.length}
                    next={handleLoadMoreData}
                    hasMore={cycleCounts.length < totalCycleCounts}
                    loader={<p className="mt-2 text-center">Loading...</p>}
                    scrollThreshold={0.95} // or "200px"
                    endMessage={
                      <p className="mt-2 text-center">
                        No more cycle counts to load
                      </p>
                    }
                  >
                    <div className="overflow-hidden card-custom">
                      <DataTable
                        value={cycleCounts}
                        dataKey="id"
                        tableClassName="min-w-full bg-white divide-y divide-gray-300 text-sm inventory-items-table"
                        cellClassName="p-2 border-1-bottom-gray text-sm"
                      >
                        <Column header="Cycle #" field="name" />
                        <Column header="Created by" field="created_by_name" />
                        <Column
                          header="Warehouse Location"
                          field="warehouse_location_name"
                        />
                        <Column header="Date" body={bodyFormattedDate} />
                        <Column header="Status" body={bodyStatus} />
                        <Column header="" body={bodyMoreActions} />
                      </DataTable>
                    </div>
                  </InfiniteScroll>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
      <SlideOver
        childComponent={slideOver.childComponent}
        slideOver={slideOver}
        setSlideOver={setSlideOver}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CycleCounts)
);
